import PropTypes from 'prop-types';
import React from 'react';
import localStyles from './InviteToProjectButton.module.scss';
import { INVITE_KIND } from './inviteToProjectHitDelegation';

const INVITE_LABEL = 'Invite';

function hasValidCollaborations(collaborations) {
  return collaborations.some((b) => b && typeof b === 'object' && b.id != null);
}

/**
 * Invite control serialized into BrowseTest InstantSearch hit HTML (`data-browse-invite`).
 * Delegated clicks: `createInviteToProjectHitHandler` in `inviteToProjectHitDelegation.js`.
 */
const InviteToProjectButton = ({
  user,
  collaborations,
  isLoadingOwnBriefs,
}) => {
  if (!user) {
    return null;
  }

  const trimmedUser =
    user.username != null && String(user.username).trim() !== ''
      ? String(user.username).trim()
      : '';
  if (!trimmedUser) {
    return null;
  }

  const uid =
    user.id != null && String(user.id).trim() !== ''
      ? String(user.id).trim()
      : '';

  const list = Array.isArray(collaborations) ? collaborations : [];
  const hasValidCollabs = hasValidCollaborations(list);

  const hireLink = (
    <a
      href={`/${trimmedUser}/hire`}
      className={localStyles.inviteControl}
      data-browse-invite={INVITE_KIND.HIRE}
      data-username={trimmedUser}
    >
      {INVITE_LABEL}
    </a>
  );

  if (isLoadingOwnBriefs) {
    return (
      <button
        type="button"
        className={localStyles.inviteControl}
        disabled
        data-browse-invite={INVITE_KIND.LOADING}
        data-username={trimmedUser}
      >
        {INVITE_LABEL}
      </button>
    );
  }

  if (!hasValidCollabs) {
    return hireLink;
  }

  if (uid) {
    return (
      <button
        type="button"
        className={localStyles.inviteControl}
        data-browse-invite={INVITE_KIND.CHOOSER}
        data-username={trimmedUser}
        data-user-id={uid}
      >
        {INVITE_LABEL}
      </button>
    );
  }

  return hireLink;
};

InviteToProjectButton.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  collaborations: PropTypes.array,
  isLoadingOwnBriefs: PropTypes.bool,
};

InviteToProjectButton.defaultProps = {
  user: null,
  collaborations: [],
  isLoadingOwnBriefs: false,
};

export default InviteToProjectButton;
